var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.$store.state.app.allUsers),function(user){return _c('v-flex',{key:user.id,attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"px-2 py-2"},[_c('UserItem',{attrs:{"user":user}})],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }